class PickerStorage {

  constructor () {
    this.pickerCollection = new PickerCollection()
  }

  async fetch() {
    const allPickers = this.getAllArray()
    if (allPickers.length > 0 && allPickers[0].id) {
      return
    }
    
    const MAX_COUNT = 5000;
    const PER_PAGE = 250
    const pickersArr = (await Promise.all(Array.from(Array(MAX_COUNT / PER_PAGE)).map(async(_, i) => {
      const result = await fetch(`/collections.json?limit=${PER_PAGE}&page=${i + 1}`);
      const data = await result.json();
      if (!data.collections) {
        return []
      }

      return data.collections.map(c => {
        const regex = /instagram\.com\/([a-zA-Z0-9_.-]+)/;
        const match = c.description?.match(regex);
        const instagramId = match ? match[1] : null
        
        // 出品者以外は除外する
        // if (!instagramId && !c.image) {
        //   return null
        // }

        return {
          id: c.id,
          title: c.title,
          image: c.image?.src ?? null,
          url: `/collections/${c.handle}`,
          handle: c.handle,
          instagramId
        }
      }).filter(c => !!c)
    }))).flat()
    const pickers = pickersArr.reduce((prev, next) => {
      if (!next.id) {
        return prev
      }

      return {
        ...prev,
        [next.id]: next
      }
    }, {})

    sessionStorage.setItem("pickers", JSON.stringify(pickers))
  }

  sync({pickerId, pickerHandle}) {
    if (this.getAll()[pickerId]) {
      return
    }

    const picker = this.pickerCollection.searchByHandle(pickerHandle)
    if (!picker) {
      return
    }

    const pickers = this.getAll()
    pickers[pickerId] = picker
    sessionStorage.setItem("pickers", JSON.stringify(pickers))
  }

  /**
   * key-value形式のオブジェクトを返します。
   * keyはピッカーのID、valueはピッカーの情報を含むオブジェクトです。
   * @returns {Object}
   */
  getAll() {
    return JSON.parse(sessionStorage.getItem("pickers") ?? "{}")
  }

  /**
   * ピッカーの情報を含むオブジェクトの配列を返します。
   * @returns {Object[]}
   */
  getAllArray() {
    return Object.values(this.getAll())
  }

  /**
   * ピッカーの情報を含むオブジェクトの配列を返します。
   * インスタグラムIDかタイトルでフィルタリングします。
   * @param {string} q - 検索クエリ
   * @returns {Object[]}
   */
  search(q) {
    const result = [];
    const pickers = this.getAllArray();
    const limit = 7;

    for (let i = 0; i < pickers.length; i++) {
      if (
        pickers[i].instagramId?.toLowerCase().startsWith(q.toLowerCase()) ||
        pickers[i].title?.toLowerCase().startsWith(q.toLowerCase())
      ) {
        result.push(pickers[i]);
        if (result.length === limit) {
          break; // 最初の5件を取得したら終了
        }
      }
    }

    return result;
  }

  /**
   * ハンドルでピッカーを検索します。idによる検索の方が高速のため、そちらを使用できないか検討してください。
   * @param {string} handle - ハンドル
   * @returns {Object}
   */
  searchByHandle(handle) {
    return this.getAllArray().find(p => p.handle === handle)
  }

  /**
   * IDでピッカーを検索します。
   * @param {string} id - ID
   * @returns {Object}
   */
  searchById(id) {
    return this.getAll()[id]
  }

}
